import React from 'react';
import { useTranslation } from 'react-i18next';
import DateRangeChip from './DateRangeChip';
import PropertyChip from './PropertyChip';
import TenantChip from './TenantChip';
import { useDashboardFilters } from './useDashboardFilters';
import './dashboard-filters.css';

/**
 * Sticky chip bar shown above the WidgetGrid and the V3 Tenant Dashboard.
 *
 * Date + Property always shown. The Tenant chip is opt-in via `showTenantChip`
 * (passed from pages that scope by tenant — e.g. /v3/tenant). The Widget Grid
 * keeps the smaller chip set so the bar doesn't clutter the default dashboard.
 *
 * `singleTenant` constrains the tenant chip to a single selection — used by the
 * single-tenant dashboard (/v3/tenant) where only one tenant drives the page.
 */
export default function DashboardFilterBar({ showTenantChip = false, singleTenant = false }) {
    const { t } = useTranslation();
    const { reset } = useDashboardFilters();

    return (
        <div className="v3-df-bar" role="region" aria-label={t('Dashboard filters')}>
            <div className="v3-df-chips">
                <DateRangeChip />
                <PropertyChip />
                {showTenantChip && <TenantChip singleSelect={singleTenant} />}
            </div>
            <div className="v3-df-bar-trailing">
                <button type="button" className="v3-df-reset" onClick={reset} title={t('Reset filters')}>
                    {t('Reset')}
                </button>
            </div>
        </div>
    );
}
